import { useContext, useState } from "react";
import ActivityChip from "./ActivityChip";
import { Copy, Plus } from 'lucide-react';
import { ProgramContext } from "../../context/ProgramsContext";
import toast from "react-hot-toast";

const DayCard = ({ day, onSelectDay, isSelected, onAddActivityClick, onDrop, draggedActivity, setDraggedActivity, reorderActivityWithinDay, ...props }) => {

    const {
        today,
        ensureDateObject,
        formatDate,
        isSameDay,
        isPast,
        headerData,
        showCopyModal,
        setShowCopyModal
    } = useContext(ProgramContext)
    const dayOfWeek = ensureDateObject(day.date).toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
    const isToday = isSameDay(day.date, today);
    const dayIsPast = isPast(day.date);
    const dayHasCompletedActivities = day.activities?.some((e) => e?.is_incomplete || e?.is_complete || e?.is_skipped)


    return (
        <>
            <div
                onDrop={(e) => onDrop(e, { dropZone: 'day', dayId: day.id })}
                onDragOver={dayIsPast ? null : (e) => e.preventDefault()}
                onClick={() => onSelectDay(day.id)}
                className={`flex-1 min-w-[180px] bg-gray-50 rounded-xl border-2 transition-all p-3 flex flex-col group
                ${isSelected ? 'border-blue-500' : 'border-transparent'}
                ${isToday ? 'bg-blue-50' : dayIsPast ? 'bg-[#eeeeee]' : ''}
            `}
            >
                {/* Day Header */}
                <div className="flex justify-between items-center mb-2">
                    <span className="font-bold text-gray-700">{dayOfWeek}</span>
                    <span className="text-sm text-gray-500">{formatDate(day.date)}</span>

                    {!dayIsPast && (
                        <div className="flex flex-row items-center gap-2">
                            <button
                                disabled={dayHasCompletedActivities}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowCopyModal(day)
                                    console.log("COPY FROM DAY")
                                }}
                                className="p-1 rounded-full bg-[#166273]/10 text-[#166273] disabled:bg-gray-200 disabled:text-gray-600 disabled:cursor-[not-allowed] opacity-0 group-hover:opacity-100 transition-opacity hover:scale-110"
                            >
                                <Copy size={16} />
                            </button>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!headerData?.problemArea) {
                                        toast.error("Please select a problem area")
                                    }
                                    else if (!headerData?.cpgProtocol) {
                                        toast.error("Please select a cpg protocol")
                                    } else if (!headerData?.subtype) {
                                        toast.error("Please select a subtype")
                                    }
                                    else {
                                        onAddActivityClick(day.id);
                                    }
                                }}
                                className="p-1 rounded-full bg-[#166273]/10 text-[#166273] opacity-0 group-hover:opacity-100 transition-opacity hover:scale-110"
                            >
                                <Plus size={16} />
                            </button>
                        </div>
                    )}
                </div>

                {/* Activities */}
                <div className="flex-grow min-h-[100px]">
                    {day.activities.map((act) => (
                        <ActivityChip
                            key={act.id}
                            {...props}
                            dayId={day.id}
                            activity={act}
                            isLocked={dayIsPast}
                            onDrop={onDrop}
                            draggedActivity={draggedActivity}
                            setDraggedActivity={setDraggedActivity}
                            reorderActivityWithinDay={reorderActivityWithinDay}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default DayCard;